import { Injectable } from '@angular/core';
import { Usuario } from '../model/usuario';


import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service'

@Injectable()
export class IngresoService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }


  find(usuario: Usuario): Observable<any> {

    let json = { "Metodo": "Ingreso", "Datos": usuario };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    
    let test = "Data=" + JSON.stringify(json);
 

    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/ingreso.service.ts